import { render, staticRenderFns } from "./EditorSingleComment.vue?vue&type=template&id=5a50b40e&scoped=true&"
import script from "./EditorSingleComment.vue?vue&type=script&lang=js&"
export * from "./EditorSingleComment.vue?vue&type=script&lang=js&"
import style0 from "./EditorSingleComment.vue?vue&type=style&index=0&id=5a50b40e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a50b40e",
  null
  
)

export default component.exports